import React from "react";
import { Box } from "@material-ui/core";
import TagLink from "components/atoms/TagLink";
type Props = {
  showTitle: boolean;
  tags: any;
};

export default function ArticleTags(props: Props) {
  const { tags, showTitle } = props;

  return tags && tags.items && tags.items.length > 0 ? (
    <>
      {showTitle && <h6>関連タグ</h6>}

      <Box display="flex" flexWrap="wrap" flexDirection="colmun">
        {tags.items.map((tag: any, key: number) => (
          <Box m={1} key={key}>
            <TagLink tag={tag.tag} />
          </Box>
        ))}
      </Box>
    </>
  ) : null;
}
